import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
var NumberUtils = /** @class */ (function () {
    function NumberUtils() {
        this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
    }
    Object.defineProperty(NumberUtils, "MILLION", {
        get: function () { return 1000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "BILLION", {
        get: function () { return 1000000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "LAKHS", {
        get: function () { return 10000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "THOUSANDS", {
        get: function () { return 1000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    NumberUtils.prototype.autoScale = function (value) {
        var suffix = '';
        try {
            var x = parseFloat(value);
            var opr = x > 0 ? 1 : -1;
            x = Math.abs(x);
            if (x > NumberUtils.BILLION) {
                value = x / (NumberUtils.BILLION);
                suffix = 'Bil';
            }
            else if (x > NumberUtils.MILLION) {
                value = x / (NumberUtils.MILLION);
                suffix = 'Mil';
            }
            else if (x > NumberUtils.LAKHS) {
                value = x / (NumberUtils.THOUSANDS);
                suffix = 'K';
            }
            value = opr == -1 ? -Math.abs(value) : value;
        }
        catch (e) { }
        return { value: value, suffix: suffix };
    };
    NumberUtils.prototype.autoFormat = function (x) {
        try {
            var val = this.autoScale(x);
            return this.numberWithCommas(val.value) + " " + val.suffix;
        }
        catch (e) {
            return '';
        }
    };
    NumberUtils.prototype.numberWithCommas = function (val) {
        try {
            var x = Math.round(val * 100) / 100;
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }
        catch (e) {
            return 0;
        }
    };
    NumberUtils.prototype.checkDecimalPoints = function (event, dp) {
        var val = event.target.value.trim();
        var dec = val.split('.');
        var decimals = "";
        if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
            event.target.value = val.slice(0, -1);
            return;
        }
        else {
            if (dec.length > 1) {
                decimals = dec[1];
            }
            else {
                return;
            }
            if (val != "" && (decimals && decimals.length > dp)) {
                console.log("Initial ", val);
                var f = parseFloat(val);
                var np = f.toFixed(dp);
                event.target.value = np;
                console.log("Changed ", event.target.value);
            }
        }
    };
    return NumberUtils;
}());
export { NumberUtils };



// WEBPACK FOOTER //
// ./src/app/shared/services/number.utils.ts.pre-build-optimizer.js